export default __webpack_public_path__ + "static/bwtransport-7-a58c927fa5bf9c866a67163576b30d43.png";